import { jsx as _jsx } from "react/jsx-runtime";
import useApi from '@/hoc/hooks/useApi';
import { useEffect, useMemo, useState } from 'react';
import SkeletonBoard from './kanban-skeleton';
import NestedColumn from './nested-columns';
export default function DynamicColumns(_a) {
    var handleEmail = _a.handleEmail, handleSchedule = _a.handleSchedule, handleScheduleAiInterview = _a.handleScheduleAiInterview;
    var jobId = useMemo(function () {
        var urlParams = new URLSearchParams(window.location.search);
        var jobId = urlParams.get('job_id') || urlParams.get('jobId');
        return jobId;
    }, []);
    var representativeId = useMemo(function () {
        var urlParams = new URLSearchParams(window.location.search);
        return urlParams.get('representative_id');
    }, []);
    var pathname = window.location.pathname;
    var isType = pathname.includes('/submitted-profiles') || pathname.includes('/submitted-profile')
        ? 'staffing'
        : 'default';
    var queryString = useMemo(function () {
        var params = new URLSearchParams();
        if (jobId)
            params.append('job_id', jobId);
        params.append('is_type', isType);
        if (isType === 'staffing' && representativeId) {
            params.append('representative_id', representativeId);
        }
        return params.toString();
    }, [jobId, isType, representativeId]);
    var _b = useApi("/candidate?".concat(queryString)), data = _b.data, loading = _b.loading, error = _b.error, fetchData = _b.fetchData;
    useEffect(function () {
        fetchData();
    }, [fetchData, jobId]);
    var _c = useState({}), items = _c[0], setItems = _c[1];
    useEffect(function () {
        setItems((data === null || data === void 0 ? void 0 : data.data) || {});
    }, [data]);
    var stagesOptions = Object.keys((data === null || data === void 0 ? void 0 : data.data) || {});
    if (loading) {
        return _jsx(SkeletonBoard, {});
    }
    return (_jsx("div", { className: 'w-full bg-containerBackground overflow-x-auto scrollbar-hide ', children: _jsx(NestedColumn, { data: items, jobId: +jobId, fetchData: fetchData, stagesOptions: stagesOptions, handleEmail: handleEmail, handleSchedule: handleSchedule, handleScheduleAiInterview: handleScheduleAiInterview }) }));
}
